import type { GenericAbortSignal } from "axios";
import { createInfiniteQuery } from "react-query-kit";

import { axiosClient } from "@/api";
import type { IWithInfinite } from "@api/types.ts";
import { getApi } from "@api/apiPath";
import type { IOption } from "@/interfaces";
import type { ID } from "@constants";

const { key, getPath } = getApi("infinite.getAllMsp");

type IResponse = IWithInfinite<IOption>;
interface IVariables {
  type?: ID;
}

const getAllInfiniteMsp = async (
  props: IVariables & { cursor: number },
  signal?: GenericAbortSignal,
): Promise<IResponse> => {
  const { data } = await axiosClient.get(getPath(), {
    params: props,
    signal,
  });

  return data.data;
};

export const useGetAllInfiniteMsp = createInfiniteQuery<IResponse, IVariables>({
  primaryKey: `infinite_${key}`,
  queryFn: ({ queryKey: [_primaryKey, variables], pageParam, signal }) =>
    getAllInfiniteMsp({ ...variables, cursor: pageParam }, signal),
  getNextPageParam: (lastPage) => lastPage.nextCursor,
  //   initialPageParam: 1
});
